export const nl = {
  pdfStorageKey: 'PDF-opslagsleutel',
  remarks: 'Opmerkingen',
  startTime: 'Starttijd',
  endTime: 'Eindtijd',

  customer: {
    name: 'Naam klant',
    email: 'E-mailadres klant',
    phone: 'Telefoonnummer klant',
    billingEmail: 'Facturatie-e-mailadres klant',
    billingPhone: 'Facturatie-telefoonnummer klant',
    taxNumber: 'Belastingnummer klant',
    iban: 'IBAN klant',
    bic: 'BIC klant',
    auth0Issuer: 'Auth0-uitgever klant',
    auth0Audience: 'Auth0-doelgroep klant',
  },

  fromAddress: {
    street: 'Straat van vertrekadres',
    city: 'Plaats van vertrekadres',
    postalCode: 'Postcode van vertrekadres',
    street2: 'Adresregel 2 van vertrekadres',
    houseNumber: 'Huisnummer van vertrekadres',
    country: 'Land van vertrekadres',
    suffix: 'Toevoeging van vertrekadres',
    longitude: 'Lengtegraad van vertrekadres',
    latitude: 'Breedtegraad van vertrekadres',
  },

  toAddress: {
    street: 'Straat van bestemmingsadres',
    city: 'Plaats van bestemmingsadres',
    postalCode: 'Postcode van bestemmingsadres',
    street2: 'Adresregel 2 van bestemmingsadres',
    houseNumber: 'Huisnummer van bestemmingsadres',
    country: 'Land van bestemmingsadres',
    suffix: 'Toevoeging van bestemmingsadres',
    longitude: 'Lengtegraad van bestemmingsadres',
    latitude: 'Breedtegraad van bestemmingsadres',
  },

  fromPerson: {
    type: 'Type afzender',
    name: 'Naam afzender',
    vatNumber: 'Btw-nummer afzender',
    address: {
      street: 'Straat van afzender',
      city: 'Plaats van afzender',
      postalCode: 'Postcode van afzender',
      street2: 'Adresregel 2 van afzender',
      houseNumber: 'Huisnummer van afzender',
      country: 'Land van afzender',
      suffix: 'Toevoeging van afzender',
      longitude: 'Lengtegraad van afzender',
      latitude: 'Breedtegraad van afzender',
    },
  },

  toPerson: {
    type: 'Type ontvanger',
    name: 'Naam ontvanger',
    vatNumber: 'Btw-nummer ontvanger',
    address: {
      street: 'Straat van ontvanger',
      city: 'Plaats van ontvanger',
      postalCode: 'Postcode van ontvanger',
      street2: 'Adresregel 2 van ontvanger',
      houseNumber: 'Huisnummer van ontvanger',
      country: 'Land van ontvanger',
      suffix: 'Toevoeging van ontvanger',
      longitude: 'Lengtegraad van ontvanger',
      latitude: 'Breedtegraad van ontvanger',
    },
  },

  carrier: {
    name: 'Naam vervoerder',
    vatNumber: 'Btw-nummer vervoerder',
    governanceNumber: 'Registratienummer vervoerder',
    address: {
      street: 'Straat van vervoerder',
      city: 'Plaats van vervoerder',
      postalCode: 'Postcode van vervoerder',
      street2: 'Adresregel 2 van vervoerder',
      houseNumber: 'Huisnummer van vervoerder',
      country: 'Land van vervoerder',
      suffix: 'Toevoeging van vervoerder',
      longitude: 'Lengtegraad van vervoerder',
      latitude: 'Breedtegraad van vervoerder',
    },
  },

  truck: {
    licensePlate: 'Kenteken vrachtwagen',
    tarra: 'Tarragewicht vrachtwagen',
    tarraMeasurementUnit: 'Eenheid tarragewicht',
    volume: 'Volume vrachtwagen',
    volumeMeasurementUnit: 'Volume-eenheid vrachtwagen',
  },

  bgb: {
    field1Role: 'Rol veld 1',
    field5Role: 'Rol veld 5',
    isCollectionScheme: 'Is inzamelregeling',
    isRouteCollection: 'Is route-inzameling',
    isRecurringTransport: 'Is terugkerend transport',
    obCodeLoad: 'OB-code laden',
    obCodeUnload: 'OB-code lossen',

    field1: {
      type: 'Type veld 1',
      name: 'Naam veld 1',
      vatNumber: 'Btw-nummer veld 1',
      address: {
        street: 'Straat veld 1',
        city: 'Plaats veld 1',
        postalCode: 'Postcode veld 1',
        street2: 'Adresregel 2 veld 1',
        houseNumber: 'Huisnummer veld 1',
        country: 'Land veld 1',
        suffix: 'Toevoeging veld 1',
        longitude: 'Lengtegraad veld 1',
        latitude: 'Breedtegraad veld 1',
      },
    },

    field2: {
      type: 'Type veld 2',
      name: 'Naam veld 2',
      vatNumber: 'Btw-nummer veld 2',
      address: {
        street: 'Straat veld 2',
        city: 'Plaats veld 2',
        postalCode: 'Postcode veld 2',
        street2: 'Adresregel 2 veld 2',
        houseNumber: 'Huisnummer veld 2',
        country: 'Land veld 2',
        suffix: 'Toevoeging veld 2',
        longitude: 'Lengtegraad veld 2',
        latitude: 'Breedtegraad veld 2',
      },
    },

    field4a: {
      type: 'Type veld 4a',
      name: 'Naam veld 4a',
      vatNumber: 'Btw-nummer veld 4a',
      address: {
        street: 'Straat veld 4a',
        city: 'Plaats veld 4a',
        postalCode: 'Postcode veld 4a',
        street2: 'Adresregel 2 veld 4a',
        houseNumber: 'Huisnummer veld 4a',
        country: 'Land veld 4a',
        suffix: 'Toevoeging veld 4a',
        longitude: 'Lengtegraad veld 4a',
        latitude: 'Breedtegraad veld 4a',
      },
    },

    field5: {
      type: 'Type veld 5',
      name: 'Naam veld 5',
      vatNumber: 'Btw-nummer veld 5',
      address: {
        street: 'Straat veld 5',
        city: 'Plaats veld 5',
        postalCode: 'Postcode veld 5',
        street2: 'Adresregel 2 veld 5',
        houseNumber: 'Huisnummer veld 5',
        country: 'Land veld 5',
        suffix: 'Toevoeging veld 5',
        longitude: 'Lengtegraad veld 5',
        latitude: 'Breedtegraad veld 5',
      },
    },
  },

  ecmr: 'e-CMR',
  template: 'Sjabloon',
  weighing1: 'Weging 1',
  weighing2: 'Weging 2',
  action: 'Acties',

  table: {
    noResults: 'Geen resultaten',
    pageOf: '{{page}} van {{total}}',
    selectPage: 'Selecteer pagina',
    pageSize: 'Per pagina',
  },
}
